module.exports = __webpack_public_path__ + "static/img/Mackenzie-Oceania.bc41b2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mackenzie-Oceania.jpg
// module id = fMwY
// module chunks = 1